import type { IconProps } from '../../types';

export const ExpandFilledIcon = ({
  className,
  color = 'currentColor',
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M14.938 5H9.06903C6.51976 5 5 6.519 5 9.067V14.926C5 17.481 6.51976 19 9.06903 19H14.9309C17.4802 19 19 17.481 19 14.933V9.067C19.007 6.519 17.4872 5 14.938 5ZM16.7308 10.6C16.7308 10.887 16.4927 11.125 16.2056 11.125C15.9184 11.125 15.6803 10.887 15.6803 10.6V9.067L9.06903 15.675H10.6028C10.8899 15.675 11.1281 15.913 11.1281 16.2C11.1281 16.487 10.8899 16.725 10.6028 16.725H7.8014C7.73136 16.725 7.66133 16.711 7.59829 16.683C7.47223 16.627 7.36718 16.529 7.31115 16.396C7.29014 16.333 7.27613 16.27 7.27613 16.2V13.4C7.27613 13.113 7.51425 12.875 7.8014 12.875C8.08854 12.875 8.32666 13.113 8.32666 13.4V14.933L14.938 8.325H13.4042C13.117 8.325 12.8789 8.087 12.8789 7.8C12.8789 7.513 13.117 7.275 13.4042 7.275H16.2056C16.2756 7.275 16.3387 7.289 16.4087 7.317C16.5347 7.373 16.6398 7.471 16.6958 7.604C16.7168 7.667 16.7308 7.73 16.7308 7.8V10.6Z'
        fill={color}
      />
    </svg>
  );
};

export default ExpandFilledIcon;
